/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React from 'react';
import DatepickerRange from 'components/datepicker-range/datepicker-range';
import Invoices from './invoices';
import Translate from 'react-translate-component';

export class InvoiceWrapper extends React.Component {

  render () {
    return (
      <div className='invoices-wrapper'>
        <h2><Translate content='YOUR_INVOICES'/></h2>
        <p><Translate content='YOUR_INVOICES_TEXT'/></p>

        <DatepickerRange />
        <Invoices />
      </div>
    );
  }
}

export default InvoiceWrapper;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/invoices/invoice-wrapper.js
 **/